<p>{{ bodyText() }}</p>
<ng-content></ng-content>
<div class="pt-6 flex flex-col gap-2">
	<ui-button
		[fullWidth]="true"
		[text]="submitButtonText()"
		[disabled]="disabled()"
		(buttonClicked)="onSubmit()"
		data-cy="confirmation-overlay-submit"
		[class.px-1]="focused()"
		(focusin)="focused.set(true)"
		(focusout)="focused.set(false)"
		#confirmButton
	></ui-button>
	<ui-button
		[fullWidth]="true"
		[text]="'general.cancel' | translate"
		type="link"
		(buttonClicked)="onCancel()"
		data-cy="confirmation-overlay-cancel"
		class="px-1 pb-1"
	></ui-button>
</div>
